<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" :title="onDialogTitle">
        <v-btn
          v-if="this.selectedSchedule.driverSchedule"
          elevation="1"
          style="position: absolute; right: 10px; top: 10px;"
          @click="onDelete"
          >삭제</v-btn
        >
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" class="pb-0">
            <div class="font-weight-bold text--black subtitle-2">
              기사 : {{ driverName }}
            </div>
          </v-col>
          <v-col cols="12">
            <div class="font-weight-bold text--black subtitle-2">
              차량: {{ vehiclePlateNo }}
            </div>
          </v-col>
        </v-row>
        <v-divider class="pr-3 pb-3"></v-divider>
        <v-row class="mt-5">
          <c-time-picker
            label="근무 시작 시간"
            v-model="selectedStartTime"
            :minute-interval="10"
            :h-range="[0, 24]"
            :autoScroll="true"
            :defaultAutoScrollValue="7"
            inputWidth="200px"
          />
          <span class="px-8">~</span>
          <c-time-picker
            label="근무 종료 시간"
            v-model="selectedEndTime"
            :minute-interval="10"
            :h-range="[0, 24]"
            :autoScroll="true"
            :defaultAutoScrollValue="7"
            inputWidth="200px"
          />
        </v-row>

        <v-row class="mt-0 pt-0">
          <v-radio-group dense row v-model="selectedWorkTimeType">
            <v-radio
              class="mx-7"
              v-for="workTimeType in workTimeTypeList"
              :key="workTimeType.value"
              :label="workTimeType.label"
              :value="workTimeType.value"
            ></v-radio>
          </v-radio-group>
        </v-row>

        <v-row class="mt-5">
          <v-text-field
            label="메모"
            prepend-icon="note"
            v-model="scheduleNote"
            placeholder="20자 이내로 입력해 주세요."
            maxLength="20"
          ></v-text-field>
        </v-row>

        <v-row>
          <v-checkbox
            label="반복"
            v-model="selectedRepeat"
            class="mr-3"
            dense
          />
        </v-row>
        <v-row class="px-6">
          <v-menu
            :close-on-content-click="false"
            v-model="startMenu"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width:200px">
                <v-text-field
                  v-model="selectedRepeatStartDate"
                  prepend-icon="event"
                  readonly
                  dense
                  v-on="on"
                  :disabled="!selectedRepeat"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker
              v-model="selectedRepeatStartDate"
              firstDayOfWeek="1"
              noTitle="true"
              scrollable="true"
              :allowedDates="(v) => allowedDates(v)"
              :selectedDate="selectedRepeatStartDate"
              @input="startMenu = false"
              locale="ko-kr"
            ></c-date-picker>
          </v-menu>
          <span class="px-5">~</span>
          <v-menu
            :close-on-content-click="false"
            v-model="endMenu"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width:200px">
                <v-text-field
                  v-model="selectedRepeatEndDate"
                  prepend-icon="event"
                  readonly
                  dense
                  v-on="on"
                  :disabled="!selectedRepeat"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker
              v-model="selectedRepeatEndDate"
              firstDayOfWeek="1"
              noTitle="true"
              scrollable="true"
              :allowedDates="(v) => allowedDates(v, selectedRepeatStartDate)"
              :selectedDate="selectedRepeatEndDate"
              @input="endMenu = false"
              locale="ko-kr"
            ></c-date-picker>
          </v-menu>
        </v-row>

        <v-row>
          <v-checkbox
            v-model="dayOfWeekList"
            :disabled="!selectedRepeat"
            class="mr-3"
            dense
            label="월"
            value="MONDAY"
            hide-details
          />
          <v-checkbox
            v-model="dayOfWeekList"
            :disabled="!selectedRepeat"
            class="mr-3"
            dense
            label="화"
            value="TUESDAY"
            hide-details
          />
          <v-checkbox
            v-model="dayOfWeekList"
            :disabled="!selectedRepeat"
            class="mr-3"
            dense
            label="수"
            value="WEDNESDAY"
            hide-details
          />
          <v-checkbox
            v-model="dayOfWeekList"
            :disabled="!selectedRepeat"
            class="mr-3"
            dense
            label="목"
            value="THURSDAY"
            hide-details
          />
          <v-checkbox
            v-model="dayOfWeekList"
            :disabled="!selectedRepeat"
            class="mr-3"
            dense
            label="금"
            value="FRIDAY"
            hide-details
          />
          <v-checkbox
            v-model="dayOfWeekList"
            :disabled="!selectedRepeat"
            class="mr-3"
            dense
            label="토"
            value="SATURDAY"
            hide-details
          />
          <v-checkbox
            v-model="dayOfWeekList"
            :disabled="!selectedRepeat"
            class="mr-3"
            dense
            label="일"
            value="SUNDAY"
            hide-details
          />
        </v-row>

        <v-row justify="center" class="mt-5">
          <c-btn
            class="mr-1 mt-2"
            color="blue"
            outlined
            :disabled="updateDisabledByRole"
            @click="onSave"
            >등록</c-btn
          >
          <c-btn class="mt-2" color="grey" outlined @click="openFlag = false"
            >취소</c-btn
          >
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    selectedSchedule: {
      type: Object,
    },
    selectedDate: {
      type: String,
    },
  },
  data() {
    return {
      openFlag: false,
      startMenu: false,
      endMenu: false,
      selectedStartTime: null,
      selectedEndTime: null,
      scheduleNote: "",

      selectedWorkTimeType: -1,
      workTimeTypeList: [
        { label: "휴무", value: "1wg_24_0" },
        { label: "08:00 ~ 17:00", value: "2wg_8_17" },
        { label: "09:00 ~ 18:00", value: "4wg_10_19" },
        { label: "10:00 ~ 19:00", value: "3wg_9_18" },
        { label: "13:00 ~ 22:00", value: "5wg_13_22" },
      ],

      selectedRepeat: false,
      selectedRepeatStartDate: this.$func.curDateString(),
      selectedRepeatEndDate: this.$func.curDateString(),
      confirm: "f",

      dayOfWeekList: [],

      driverName: "",
      vehiclePlateNo: "",
      deleteDialogOpen: false,

      scheduleId: "",
    };
  },
  watch: {
    open(newVal) {
      if (newVal) {
        const selectedSchedule = this.selectedSchedule;
        const driverSchedule = selectedSchedule.driverSchedule;

        if (driverSchedule) {
          this.selectedStartTime = driverSchedule.onWorkTime;
          this.selectedEndTime = driverSchedule.endWorkTime;
          this.scheduleNote = driverSchedule.scheduleNote;
          this.scheduleId = driverSchedule.id;
        } else {
          this.selectedStartTime = "00:00";
          this.selectedEndTime = "00:00";
          this.scheduleNote = "";
        }

        this.selectedWorkTimeType = -1;
        this.selectedRepeat = false;
        this.selectedRepeatStartDate = this.selectedDate;
        this.selectedRepeatEndDate = this.selectedDate;

        this.reqGetDriver(selectedSchedule.driverId);
        this.reqGetVehicle(selectedSchedule.vehicleId);
      }

      this.openFlag = newVal;
    },
    openFlag(newVal) {
      if (!newVal) {
        this.resetField();
      }
      this.$emit("update:open", newVal);
    },
    //TODO - hide radio check
    // selectedStartTime() {
    //   this.selectedWorkTimeType = 0;
    // },
    // selectedEndTime() {
    //   this.selectedWorkTimeType = 0;
    // },
    selectedRepeat(newVal) {
      if (!newVal) {
        this.selectedRepeatStartDate = this.selectedDate;
        this.selectedRepeatEndDate = this.selectedDate;
        this.dayOfWeekList = [];
      } else {
        this.selectedRepeatStartDate = this.selectedDate;
        this.selectedRepeatEndDate = this.$func.dateStringAddMonths(
          this.selectedRepeatStartDate,
          1
        );
        this.dayOfWeekList = [
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
        ];
      }
    },
    selectedWorkTimeType(newVal) {
      if (newVal === -1) {
        return;
      } else if (newVal === "1wg_24_0") {
        this.selectedStartTime = "00:00";
        this.selectedEndTime = "00:00";
      } else {
        let temp = this.workTimeTypeList.filter(
          (item) => item.value === newVal
        );
        temp = temp[0].label.split(" ~ ");
        this.selectedStartTime = temp[0];
        this.selectedEndTime = temp[1];
      }
    },
  },
  computed: {
    onDialogTitle() {
      return this.selectedSchedule.driverSchedule
        ? "근무 일정 변경"
        : "근무 일정 등록";
    },
    updateDisabledByRole() {
      return (
        this.$store.state.userInfo.role === "RM" &&
        this.selectedSchedule.driverSchedule
      );
    },
  },
  methods: {
    resetField() {
      this.openFlag = false;
      this.endMenu = false;
      this.startMenu = false;
      this.selectedEndTime = null;
      this.selectedStartTime = null;

      this.scheduleNote = "";
      this.selectedWorkTimeType = -1;
      this.workTimeTypeList = [
        { label: "휴무", value: "1wg_24_0" },
        { label: "08:00 ~ 17:00", value: "2wg_8_17" },
        { label: "09:00 ~ 18:00", value: "4wg_10_19" },
        { label: "10:00 ~ 19:00", value: "3wg_9_18" },
        { label: "13:00 ~ 22:00", value: "5wg_13_22" },
      ];

      this.selectedRepeat = false;
      this.selectedRepeatStartDate = this.$func.curDateString();
      this.selectedRepeatEndDate = this.$func.curDateString();
      this.confirm = "f";

      this.dayOfWeekList = [];

      this.driverName = "";
      this.vehiclePlateNo = "";
      this.deleteDialogOpen = false;
    },
    onDelete() {
      this.$store.commit("alert", {
        open: true,
        msg: `${this.driverName}님의 해당 근무 일정을 삭제하시겠습니까?`,
        confirm: true,
        persistent: true,
        callBack: () => {
          this.deleteSchedule();
        },
      });
    },
    async deleteSchedule() {
      try {
        await this.$api.deleteDriverSchedule(this.scheduleId);
        this.$emit("refetchData");
        this.openFlag = false;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "deleteSchedule" });
        return false;
      }
    },
    async onSave() {
      const isValid = await this.validateItems();

      if (!isValid) {
        return;
      }

      const reqData = {
        startDate: this.selectedRepeatStartDate,
        endDate: this.selectedRepeatEndDate,
        driverId: this.selectedSchedule.driverId,
        vehicleId: this.selectedSchedule.vehicleId,
        onWorkTime: this.selectedStartTime,
        endWorkTime: this.selectedEndTime,
        scheduleNote: this.scheduleNote,
        confirm: this.confirm,
        dayOfWeekList: this.selectedRepeat ? this.dayOfWeekList : null,
      };
      this.$emit("reqUpdateSchedule", reqData);
      this.openFlag = false;
    },
    allowedDates(date, standardDate) {
      const flag = standardDate
        ? this.$moment(date, "YYYY-MM-DD").isBefore(
            this.$moment(standardDate + " 00:00:00", "YYYY-MM-DD HH:mm:ss")
          )
        : this.$moment(date, "YYYY-MM-DD").isBefore(
            this.$moment("00:00:00", "HH:mm:ss")
          );
      return !flag;
    },
    async reqGetDriver(driverId) {
      try {
        const res = await this.$api.getDriver(driverId);
        if (res.data.driver) this.driverName = res.data.driver.name;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqGetDriver" });
      }
    },
    async reqGetVehicle(vehicleId) {
      try {
        const res = await this.$api.getVehicle(vehicleId);

        this.vehiclePlateNo = res.data.plateNo;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqGetVehicle" });
      }
    },
    async validateItems() {
      if (this.selectedRepeatStartDate > this.selectedRepeatEndDate) {
        this.$store.commit("snackbar", { msg: "반복일을 다시 확인해 주세요." });
        return false;
      }
      if (this.selectedStartTime > this.selectedEndTime) {
        this.$store.commit("snackbar", {
          msg: "근무시간을 다시 확인해 주세요.",
        });
        return false;
      }
      if (this.scheduleNote.length > 20) {
        this.$store.commit("snackbar", {
          msg: "메모를 20자 이내로 입력해 주세요. (띄어쓰기 포함)",
        });
        return false;
      }

      // 출발 일시가 올바르지 않은 경우 & 비어있는 경우
      if (!this.checkWorkingTime()) {
        this.$store.commit("snackbar", {
          where: "makeReqReservationData",
          msg: "출발 일시를 올바르게 입력해주세요.",
        });
        return false;
      }

      // 센터정보에서 예약 가능한 시간이 아닐 때
      const centerOperTimeInfoList = await this.getCenterOperTimeInfoList();
      if (centerOperTimeInfoList.length <= 0) {
        this.$store.commit("snackbar", {
          where: "makeReqReservationData",
          msg: "해당 요일은 예약이 불가능합니다.",
        });
        return false;
      }

      const combinedCenterOperTimeInfo = this.getCombinedOperTimeInfo(
        centerOperTimeInfoList
      );
      if (!this.checkEnableDriveTime(combinedCenterOperTimeInfo)) {
        this.$store.commit("alert", {
          open: true,
          title: "차량 운행 시간이 아닙니다.",
          msg: `근무 일정 등록 가능한 시간은 ${combinedCenterOperTimeInfo.startDrive} ~ ${combinedCenterOperTimeInfo.endDrive} 입니다.`,
        });

        return false;
      }

      return true;
    },
    checkWorkingTime() {
      const [startHour, startMinute] = this.selectedStartTime.split(":");
      const [endHour, endMinute] = this.selectedEndTime.split(":");

      return (
        startHour >= 0 &&
        startHour <= 23 &&
        startMinute >= 0 &&
        startMinute <= 59 &&
        endHour >= 0 &&
        endHour <= 23 &&
        endMinute >= 0 &&
        endMinute <= 59
      );
    },
    async getCenterOperTimeInfoList() {
      const res = await this.$api.getCenterOperTime(
        this.$store.state.centerInfo.centerId
      );
      let selectedWeekdays = [];
      const startMoment = this.$func.stringToDate(this.selectedRepeatStartDate);
      const endMoment = this.$func.stringToDate(this.selectedRepeatEndDate);
      const diffDays = endMoment.diff(startMoment, "days");

      if (diffDays >= 6) {
        selectedWeekdays = [0, 1, 2, 3, 4, 5, 6];
      } else {
        selectedWeekdays = Array.from({ length: diffDays + 1 }, (v, index) => {
          return startMoment.weekday() + index;
        });
      }

      const centerOperTimeInfoList = res.data.filter((centerOperTime) => {
        if (!centerOperTime) return false;

        return (
          selectedWeekdays.includes(centerOperTime.dayWeek) &&
          centerOperTime.operation === "Enable"
        );
      });

      return centerOperTimeInfoList;
    },
    getCombinedOperTimeInfo(centerOperTimeList) {
      return centerOperTimeList.reduce(
        (reducer, centerOperTime) => {
          return {
            startDrive:
              reducer.startDrive > centerOperTime.startDrive
                ? reducer.startDrive
                : centerOperTime.startDrive,
            endDrive:
              reducer.endDrive > centerOperTime.endDrive
                ? centerOperTime.endDrive
                : reducer.endDrive,
            weekDays: [...reducer.weekDays, centerOperTime.dayWeek],
          };
        },
        { startDrive: "", endDrive: "99:99", weekDays: [] }
      );
    },
    checkEnableDriveTime(centerOperTimeInfo) {
      if (!centerOperTimeInfo) {
        return false;
      }

      if (this.selectedStartTime === this.selectedEndTime) {
        // 휴무처리
        return true;
      }

      const [startWorkHour, startWorkMinute] = this.selectedStartTime.split(
        ":"
      );
      const [endWorkHour, endWorkMinute] = this.selectedEndTime.split(":");
      const [
        startDriveHour,
        startDriveMinute,
      ] = centerOperTimeInfo.startDrive.split(":");
      const [endDriveHour, endDriveMinute] = centerOperTimeInfo.endDrive.split(
        ":"
      );

      return (
        (startWorkHour > startDriveHour ||
          (startWorkHour === startDriveHour &&
            startWorkMinute >= startDriveMinute)) &&
        (endWorkHour < endDriveHour ||
          (endWorkHour === endDriveHour && endWorkMinute <= endDriveMinute))
      );
    },
  },
  mounted() {},
};
</script>
